// API address. Override with REACT_APP_API_URL (for example in frontend/.env.local).
export const API_URL = (
  process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/AtsFinance_app/finance/'
).replace(/\/?$/, '/');

export const TOKEN_KEY = 'ats_token';
export const ORG_KEY = 'ats_org';

export const TEAM_LABELS = { LI: 'Manufacturing', HC: 'Healthcare', IT: 'Information Tech' };
export const ORG_LABELS = {
  della: 'Della Infotech Inc',
  'vrd canada': 'VRD Canada',
  vezita: 'Vezita Healthcare Inc',
  combined: 'Combined',
};
// Database name used when saving rows that belong to an organization.
export const ORG_DB_NAMES = {
  della: 'Della Infotech Inc',
  vezita: 'Vezita Tech Inc',
  'vrd canada': 'VRD Canada',
};
export const ORG_ORDER = ['della', 'vrd canada', 'vezita', 'combined'];
